import { createFetchReducer } from '../helpers/fetchData'
import actions from './actions'

export const surveyQuestionTypes = createFetchReducer({ name: actions.questionTypesName })

const surveyQuestions = createFetchReducer({ name: actions.questionsName })

export default surveyQuestions
